interface MapEmbedProps {
  query: string;
  embedUrl?: string;
  linkUrl?: string;
  title?: string;
  className?: string;
}

export default function MapEmbed({
  query,
  embedUrl,
  linkUrl,
  title = "Mapa de ESPACIO BORMAN",
  className = "",
}: MapEmbedProps) {
  const src =
    embedUrl || `https://maps.google.com/maps?q=${encodeURIComponent(query)}&t=&z=12&ie=UTF8&iwloc=&output=embed`;
  const showLink = Boolean(linkUrl) && !linkUrl?.includes("/maps/embed");

  return (
    <div>
      <div className={`overflow-hidden rounded-lg border border-background-200 ${className}`}>
        <iframe
          title={title}
          src={src}
          className="w-full h-full min-h-[320px]"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          aria-label={title}
        />
      </div>
      {showLink && (
        <a
          href={linkUrl}
          target="_blank"
          rel="noreferrer"
          className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 hover:text-primary-700 transition"
        >
          <i className="ri-map-pin-line" /> Abrir en Google Maps
        </a>
      )}
    </div>
  );
}
